import { GlobalOutlined, MailOutlined, PhoneOutlined } from "@ant-design/icons";
import { Col, Form, Input, Row } from "antd";

export const ClienteContacto = () => {
  return (
    <>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={24} md={24} lg={8} xl={8} xxl={4}>
          <Form.Item name="telefono" label="Telefono">
            <Input
              placeholder="Ingrese telefono"
              addonBefore={<PhoneOutlined />}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={24} lg={8} xl={8} xxl={6}>
          <Form.Item name="email" label="Correo electrónico">
            <Input
              placeholder="Ingrese correo electrónico"
              addonBefore={<MailOutlined />}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={24} lg={8} xl={8} xxl={6}>
          <Form.Item name="website" label="Website">
            <Input placeholder="Website" addonBefore={<GlobalOutlined />} />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};
